import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17f1fff0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing course-details-card" }
const _hoisted_2 = { class: "card-body p-10" }
const _hoisted_3 = { class: "bg-gradient ps-15 pe-15 pt-20 pb-20 ps-md-30 pe-md-30 pt-md-30 pb-md-30 ps-lg-40 pe-lg-40 pt-lg-40 pb-lg-40" }
const _hoisted_4 = { class: "course-details-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block bg-warning fs-12 fw-medium rounded-1 ps-10 pe-10 pt-1 pb-1 mb-10 text-black" }, " Seguridad ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold text-white" }, "Permisos por rol", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lh-base fs-md-15 fs-lg-16" }, " Asigna los permisos de menú y ruta que cada rol puede utilizar en el sistema. ", -1))
const _hoisted_8 = { class: "info d-sm-flex align-items-center justify-content-between" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"reviews d-flex align-items-center mb-10 mb-sm-0\" data-v-17f1fff0><div class=\"rating lh-1\" data-v-17f1fff0><i class=\"flaticon-star-1\" data-v-17f1fff0></i><i class=\"flaticon-star-1\" data-v-17f1fff0></i><i class=\"flaticon-star-1\" data-v-17f1fff0></i><i class=\"flaticon-star-1\" data-v-17f1fff0></i><i class=\"flaticon-star-1\" data-v-17f1fff0></i></div><span class=\"fw-bold fs-13 ms-5 me-8 text-white\" data-v-17f1fff0>Vista árbol</span><span data-v-17f1fff0>Menús → Permisos (rutas)</span></div>", 1)
const _hoisted_10 = {
  key: 0,
  class: "text-white fs-13"
}
const _hoisted_11 = { class: "fw-semibold" }
const _hoisted_12 = { class: "fw-semibold" }
const _hoisted_13 = { class: "card-body pt-10 pb-10 ps-10 pe-10" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-black" }, "Rol", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-black" }, "Menú", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-black" }, "Buscar permiso", -1))
const _hoisted_17 = {
  key: 0,
  class: "text-muted fs-13 mt-5"
}
const _hoisted_18 = {
  key: 0,
  class: "pe-xxl-25 pe-xxxl-50"
}
const _hoisted_19 = { class: "card-body pt-0 pb-0 ps-10 pe-10" }
const _hoisted_20 = {
  class: "accordion",
  id: "menusAccordion"
}
const _hoisted_21 = ["data-bs-target", "aria-controls"]
const _hoisted_22 = { class: "d-sm-flex align-items-center justify-content-between w-100" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "number bg-primary text-center text-white rounded-circle fs-13 fw-semibold" }
const _hoisted_25 = { class: "ms-10" }
const _hoisted_26 = { class: "text-muted ms-10 fs-12" }
const _hoisted_27 = { class: "d-flex align-items-center mt-10 mt-sm-0 ps-0 mb-0 list-unstyled" }
const _hoisted_28 = { class: "position-relative fw-medium fs-13 text-muted" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-people" }, null, -1))
const _hoisted_30 = ["id"]
const _hoisted_31 = { class: "accordion-body" }
const _hoisted_32 = { class: "d-flex align-items-center" }
const _hoisted_33 = { class: "fw-semibold" }
const _hoisted_34 = { class: "text-muted fs-12" }
const _hoisted_35 = {
  key: 0,
  class: "text-muted fs-13"
}
const _hoisted_36 = {
  key: 0,
  class: "text-muted fs-14 mt-10"
}
const _hoisted_37 = {
  key: 1,
  class: "card-body pt-10 pb-15 ps-10 pe-10"
}
const _hoisted_38 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            (_ctx.selectedRoleId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createTextVNode(" Rol seleccionado: "),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.currentRoleName || ('ID ' + _ctx.selectedRoleId)), 1),
                  _createTextVNode(" · Permisos asignados: "),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.totalAssigned), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_b_row, { class: "g-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_col, { md: "4" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_group, null, {
                default: _withCtx(() => [
                  _hoisted_14,
                  _createVNode(_component_SearchSelect, {
                    modelValue: _ctx.selectedRoleId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedRoleId) = $event)),
                    modelModifiers: { number: true },
                    options: _ctx.roleOptions,
                    placeholder: "Seleccione un rol",
                    onChange: _ctx.onRoleChanged
                  }, null, 8, ["modelValue", "options", "onChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, { md: "4" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_group, null, {
                default: _withCtx(() => [
                  _hoisted_15,
                  _createVNode(_component_SearchSelect, {
                    modelValue: _ctx.menuFilter,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.menuFilter) = $event)),
                    options: _ctx.menuOptions,
                    placeholder: "Todos los menús",
                    disabled: !_ctx.selectedRoleId
                  }, null, 8, ["modelValue", "options", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_b_col, { md: "4" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_group, null, {
                default: _withCtx(() => [
                  _hoisted_16,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.search,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                    size: "sm",
                    placeholder: "Buscar por menú o ruta",
                    disabled: !_ctx.selectedRoleId
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (!_ctx.selectedRoleId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, " Seleccione un rol para visualizar y asignar permisos. "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.selectedRoleId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menusForTree, (menu, mIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: menu.name,
                  class: "accordion-item border-0"
                }, [
                  _createElementVNode("button", {
                    class: "accordion-button d-block w-100 text-start text-black fs-14 fs-md-15 fw-medium rounded-0 bg-white border-0",
                    type: "button",
                    "data-bs-toggle": "collapse",
                    "data-bs-target": `#menu-${mIdx}`,
                    "aria-controls": `menu-${mIdx}`
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString(mIdx + 1), 1),
                        _createElementVNode("span", _hoisted_25, [
                          _createTextVNode(_toDisplayString(menu.name || 'Sin menú') + " ", 1),
                          _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.assignedCountForMenu(menu.name)) + " / " + _toDisplayString(menu.routes.length) + " permisos asignados ", 1)
                        ])
                      ]),
                      _createElementVNode("ul", _hoisted_27, [
                        _createElementVNode("li", _hoisted_28, [
                          _hoisted_29,
                          _createTextVNode(" " + _toDisplayString(menu.routes.length) + " permisos disponibles ", 1)
                        ])
                      ])
                    ])
                  ], 8, _hoisted_21),
                  _createElementVNode("div", {
                    id: `menu-${mIdx}`,
                    class: "accordion-collapse collapse",
                    "data-bs-parent": "#menusAccordion"
                  }, [
                    _createElementVNode("div", _hoisted_31, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.routes, (route) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: route.Id,
                          class: "d-flex justify-content-between align-items-center py-6 border-bottom ps-4"
                        }, [
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_b_form_checkbox, {
                              class: "me-8",
                              "model-value": _ctx.isAssigned(route),
                              disabled: _ctx.table.loading,
                              variant: _ctx.isAssigned(route) ? 'success' : 'secondary',
                              "onUpdate:modelValue": (val) => _ctx.onTogglePermission(route, val)
                            }, null, 8, ["model-value", "disabled", "variant", "onUpdate:modelValue"]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_33, _toDisplayString(route.Name), 1),
                              _createElementVNode("div", _hoisted_34, _toDisplayString(route.MenuName || 'Sin menú'), 1)
                            ])
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge", _ctx.statusBadgeClass(route)])
                          }, _toDisplayString(_ctx.statusLabel(route)), 3)
                        ]))
                      }), 128)),
                      (!menu.routes.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, " No hay permisos para este menú según los filtros. "))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_30)
                ]))
              }), 128)),
              (!_ctx.menusForTree.length && !_ctx.table.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, " No hay permisos que cumplan los filtros actuales. "))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedRoleId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createVNode(_component_b_button, {
              variant: "success",
              class: "default-btn transition border-0 fw-medium text-white py-10 px-25 rounded-1 fs-14",
              disabled: !_ctx.canSave || _ctx.table.loading,
              onClick: _ctx.saveAll
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Guardar permisos ")
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}